// Core React Imports
import React from "react";

// Local Imports
import { ParagraphText, WidgetMarginHeight, DivColumn } from "../../styles/SharedStyles";

// CSS/Stylesheets
import "./WidgetTextViewData.css";

const WidgetTextViewData = ({ title, text, heightProp = "4.4rem", widthProp = "auto", colorProp = "#5A81FA", fontFamilyProp }) => {
  return (
    <DivColumn className="terminal-4-frame-9" style={{ height: heightProp, width: widthProp }}>
      <WidgetMarginHeight height="1.1rem" />
      <ParagraphText className="terminal-text-16" style={{ color: colorProp }}>
        {title}
      </ParagraphText>
      <ParagraphText className="terminal-text-17" style={{ color: colorProp, fontFamily: fontFamilyProp }}>
        {text}
      </ParagraphText>
    </DivColumn>
  );
};

export default WidgetTextViewData;
